import React from 'react';
import memoizeOne from 'memoize-one';

import type { ProviderParticipant } from '@atlaskit/editor-common/collab';
import type { AvatarProps } from '@atlaskit/avatar-group';

import { AvatarBadge } from './AvatarBadge';

const hasSameParticipantBeenUsedBefore = (
	[a]: ProviderParticipant[],
	[b]: ProviderParticipant[],
) => {
	return a.name === b.name && a.avatar === b.avatar && a.sessionId === b.sessionId;
};

export const generateAvatarDescriptorFromParticipant = memoizeOne(
	(participant: ProviderParticipant): AvatarProps => ({
		name: participant.name,
		src: participant.avatar,
		size: 'medium',
		presence: <AvatarBadge name={participant.name} sessionId={participant.sessionId} />,
	}),
	hasSameParticipantBeenUsedBefore,
);
